import React, {useCallback, useEffect, useState} from 'react';
import {moduleprops} from '../../types';
import CustomChatBubble from '../CustomChatBubble';
import colors from '../../constants/colors';
import { resolveContentUrl } from '../../utils/resolveContentUrl';
import './YetiIntroModule.css';

interface YetiIntroModuleProps extends moduleprops {
  contentBaseUrl?: string;
}

const YetiIntroModule: React.FC<YetiIntroModuleProps> = ({
  resetCounter,
  submittedVal,
  updateCurrentIndex,
  yetiIntroText,
  containerClassName = '',
  contentBaseUrl,
}) => {
  const [index, setIndex] = useState(0);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = useCallback(() => {
    setSubmitted(true);
    if (index === 1) {
      setIndex(prev => prev + 1);
    }
  }, [index]);

  useEffect(() => {
    if (submittedVal) {
      handleSubmit();
    }
  }, [submittedVal, handleSubmit]);

  useEffect(() => {
    if (resetCounter) {
      setIndex(0);
    }
  }, [resetCounter]);

  useEffect(() => {
    const duration =
      parseInt(yetiIntroText?.[index]?.object?.[0]?.duration ?? '3000', 10) +
      2000;

    const interval = setInterval(() => {
      if (index < (yetiIntroText?.length ?? 0) - 1) {
        updateCurrentIndex(index + 1);
        setIndex(prev => prev + 1);
      }
    }, duration);

    return () => clearInterval(interval);
  }, [index, submitted, updateCurrentIndex, yetiIntroText]);

  const audioUrl = resolveContentUrl(
    yetiIntroText?.[index]?.object?.[0]?.audio,
    contentBaseUrl,
  );
  const bubbleContent = yetiIntroText?.[index]?.object?.[0]?.content ?? '';

  return (
    <div className={`web-yeti-intro ${containerClassName}`}>
      <CustomChatBubble
        isOwnMessage={false}
        content={bubbleContent}
        textColor={colors.BLACK}
        audioUri={audioUrl}
        contentBaseUrl={contentBaseUrl}
      />
    </div>
  );
};

export default YetiIntroModule;
